import React from "react";

type BadgeProps = {
  color: string;
  bold?: boolean;
  fullWidth?: boolean;
  size?: "small" | "medium" | "large";
  children: React.ReactNode;
  onClick?: () => void;
};

const BadgeCustom: React.FC<BadgeProps> = ({
  color = "gray",
  size = "small",
  children,
  bold = false,
  fullWidth = false,
  onClick
}) => {
  // Define consistent height + padding
  const height =
    size === "small" ? 18 :
      size === "medium" ? 22 :
        26;

  const fontSize =
    size === "small" ? "12px" :
      size === "medium" ? "0.8rem" :
        "0.10rem";

  const weight = bold ? 600 : 300;

  return (
    <>
      <style>{`
        .badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: ${fullWidth ? "100%" : ""};
          min-width: ${fullWidth ? "" : height};
          cursor: ${!!onClick ? "pointer" : "default"};
          
          height: ${height}px;
          padding: 0.05rem 0.3rem;
          border-radius: ${height / 4.5}px; /* pill shape */
          text-align: center;
          margin: 0.2rem;
          color: white;
          white-space: nowrap;
          letter-spacing:0.005em;
        }
        .badge.red { background-color: #ed1622; }
        .badge.purple { background-color: #e6bde5; color:black }
        .badge.pink { background-color: #f36493 }
        .badge.indigo { background-color: #9caad8; }
        .badge.cyan { background-color: #bbebf0; color:black }
        .badge.lime { background-color: #d0d962; color:black }
        .badge.orange { background-color: #ff9528; }
        .badge.brown { background-color: #a58b84; }
        .badge.violet { background-color: #7a59bc }
        .badge.dark { background-color: #2b383e }
        .badge.smoke { background-color: #4a6b78 }
        .badge.neon { background-color: #88c241 }
        .badge.light { background-color: #d6d9da; color:black }
        .badge.lightgreen { background-color: #b2e1da; color:black }
        .badge.green { background-color: #43a047; }
        .badge.blue { background-color: #1e88e5; }
        .badge.yellow { background-color: #fbc02d; color: black; }
        .badge.grey { background-color: #757575; }
        .badge.lightgrey { background-color: #e3e3e3; color:black}
      `}</style>

      <span
        className={`badge ${color}`}
        onClick={onClick}
        style={{
          cursor: onClick ? "pointer" : "default",
          fontSize,
          fontWeight: weight
        }}
      >
        {children}
      </span>
    </>
  );
};

export default BadgeCustom;
